export default "__VITE_ASSET__Mfd8Lm$0__"